import { setSessionStorageItem } from '../../sessionStorage/utils';
import {
  SESSION_STORAGE_LAST_BROWSE_PARAMS,
  SESSION_STORAGE_LAST_SEARCH_PARAMS,
} from '../../../utils/constants';

const saveSearchParams = (newSearchParams, searchParamsVar) => {
  searchParamsVar(newSearchParams);
  setSessionStorageItem(SESSION_STORAGE_LAST_SEARCH_PARAMS, newSearchParams);
};

const saveBrowseParams = (newBrowseParams, browseParamsVar) => {
  browseParamsVar(newBrowseParams);
  setSessionStorageItem(SESSION_STORAGE_LAST_BROWSE_PARAMS, newBrowseParams);
};

export const createSetSearchParams = (searchParamsVar) => {
  return (newSearchParams) => {
    saveSearchParams(newSearchParams, searchParamsVar);
  };
};

export const createSetTravelerInformation = (searchParamsVar) => {
  return (newTravelerInformation) => {
    const currentSearchParams = searchParamsVar();

    const newSearchParams = {
      ...searchParamsVar(),
      guests: currentSearchParams.guests.map((guest, index) => {
        return {
          ...guest,
          flightGuest: {
            ...guest.flightGuest,
            middleName: newTravelerInformation[index].middleName,
            knownTravelerNumber: newTravelerInformation[index].knownTravelerNumber,
            redressNumber: newTravelerInformation[index].redressNumber,
            loyaltyPrograms: newTravelerInformation[index].loyaltyPrograms,
          },
        };
      }),
    };
    saveSearchParams(newSearchParams, searchParamsVar);
  };
};

export const createSetBrowseParams = (browseParamsVar) => {
  return (newBrowseParams) => {
    saveBrowseParams(newBrowseParams, browseParamsVar);
  };
};
